<template>
  <custom-dialog class="resource-item-dialog" width="1200px" :title="title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <div class="content">
          <div class="resource-msg">
            <div class="title">{{ $t('dms_resource_item_dialog.zi_yuan_xin_xi') }}</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.zi_yuan_ming_cheng')" prop="resourceName" :rules="rules.resourceName">
                  <el-input v-model="form.resourceName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.zi_yuan_ban_ben')" prop="resourceVersion" :rules="rules.resourceVersion">
                  <el-input v-model="form.resourceVersion"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.zi_yuan_lei_bie')" prop="resourceClass" :rules="rules.resourceClass">
                  <custom-select code="resource_class" v-model="form.resourceClass" :clearable="false"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.zi_yuan_lei_xing')" prop="resourceType" :rules="rules.resourceType">
                  <custom-select code="resource_type" v-model="form.resourceType" :clearable="false"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.xie_yi_lei_bie')" prop="protocolClass" :rules="rules.protocolClass">
                  <custom-select placeholder="" code="iot_protocol_class" v-model="form.protocolClass"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.zhi_chi_xing_hao')" prop="protocolCode" :rules="rules.protocolCode">
                  <!-- <el-input v-model="form.protocolCode" ></el-input> -->
                  <custom-select
                    :auto="false"
                    filterable
                    multiple
                    :listener="form.protocolClass"
                    url="resourceProtocolSelectList"
                    v-model="form.protocolCode"
                    :props="{ label: 'protocolDesc', value: 'protocolCode' }"
                    :params="{ protocolClass: form.protocolClass }"
                    width="100%"
                  ></custom-select>
                  <!-- @change="onChangeProductCode" -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.xia_fa_mo_kuai')" prop="tcpModule" :rules="rules.tcpModule">
                  <custom-select placeholder="" code="tcp_module" v-model="form.tcpModule"></custom-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('dms_resource_item_dialog.zi_yuan_zhuang_tai')" prop="state" :rules="rules.state">
                  <custom-select v-model="form.state" code="cloud_valid_invalid_state" width="100%"></custom-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_resource_item_dialog.zcjqbb')">
                  <custom-table
                    ref="table"
                    height="180px"
                    :data="form.machineVersionList"
                    tableCode="resource_protocol_detail"
                    @sort="sortChange"
                    @filter="filterChange"
                    index
                    :slots="[ 'action']"
                  >
                    <template v-slot:action="scope">
                      <span>
                        <el-button type="text" size="mini"  @click="deleteResource(scope.$index)">{{ $t('Common.com_delete') }}</el-button>
                      </span>
                    </template>
                  </custom-table>
                  <div class="add-child-btn" @click="onSelDevice" v-if="form.protocolClass">
                    <div style="display: inline-block">
                      <i class="icon icon-add"></i>
                      <span>{{ $t('dms_resource_item_dialog.zcjqbb') }}</span>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_resource_item_dialog.xxjrbbh')" prop="supportPreVersion" :rules="rules.supportPreVersion">
                  <!-- <custom-select
                    url="resourceSelectList"
                    :listener="`${form.protocolClass}${form.resourceClass}${form.resourceType}${form.tcpModule}`"
                    :auto="false"
                    filterable
                    multiple
                    v-model="form.supportPreVersion"
                    :params="{protocolClass:form.protocolClass,resourceClass:form.resourceClass,resourceType:form.resourceType,tcpModule:form.tcpModule}"
                    :props="{
                      label: 'resourceVersion',
                      value: 'resourceVersion',
                    }"
                    width="100%"
                    ref="supportPreVersion"
                  ></custom-select> -->
                  <!-- 2022-4-7 呆萌说改成input框 -->
                  <el-input v-model="form.supportPreVersion"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('dms_resource_item_dialog.zi_yuan_miao_shu')" prop="resourceDesc">
                  <el-input type="textarea" rows="3" maxlength="500" v-model="form.resourceDesc" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="handle-file">
            <div class="title">{{ $t('dms_resource_item_dialog.zi_yuan_wen_jian') }}</div>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_resource_item_dialog.zi_yuan_wen_jian')" prop="attachId" :rules="rules.attachId">
                  <!--  -->
                  <t-upload
                    type="file"
                    :bizId="form.resourceId"
                    :limit="1"
                    :bizType="form.attachBizType"
                    v-model="form.fileList"
                    :tip="$t('dms_resource_item_dialog.zcdgwj1024Myn')"
                    ref="iotFirmware"
                    :autoUpload="false"
                  ></t-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
    <select-device-dialog
      v-if="selectDeviceVisible"
      @close="selectDeviceVisible=false"
      :model="selectDeviceModel"
      @confirm="selDeviceConfirm"
    ></select-device-dialog>
  </custom-dialog>
</template>

<script>
import tUpload from '@/components/upload.vue';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import selectDeviceDialog from './select_device_dialog';

export default {
  mixins: [dialogMixins],
  props: {
    // model: {
    //   data: { eventId }
    // }
  },
  components: { tUpload, selectDeviceDialog },
  computed: {
    rules() {
      return {
        resourceName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        resourceVersion: {
          required: true,
          message: this.$t('Common.com_required')
        },
        resourceClass: {
          required: true,
          message: this.$t('Common.com_required')
        },
        resourceType: { required: true, message: this.$t('Common.com_required') },
        protocolClass: { required: true, message: this.$t('Common.com_required') },
        protocolCode: { trigger: ['blur'], required: true, message: this.$t('Common.com_required'), type: 'array', },
        tcpModule: { required: true, message: this.$t('Common.com_required') },
        state: { required: true, message: this.$t('Common.com_required') },
        attachId: { required: true, message: this.$t('Common.com_required') },
      };
    },
    title() {
      if (this.model.title) {
        return this.model.title;
      }
      return this.model.type === 'add' ? this.$t('dms_resource_item_dialog.xin_zeng_zi_yuan') : this.$t('dms_resource_item_dialog.bian_ji_zi_yuan');
    },
  },
  data() {
    return {
      productQuery: {
        productCode: '',
      },
      componentSelectKey: Math.random(),
      curProductSn: '',
      // 部件列表
      componentList: [],
      form: {
        resourceId: '',
        resourceName: '', // 资源名称
        resourceVersion: '', // 资源版本
        resourceClass: '', // 资源类别 iot_tsl_module，
        resourceType: '', // 资源类型 iot_tsl_module，
        protocolClass: '', // 协议类别 iot_protocol_class，
        protocolCode: [], // 支持协议
        tcpModule: '', // 下发模块  iot_tsl_module，
        state: 1, // 资源状态
        supportPreVersion: '', // 向下兼容版本号
        resourceDesc: '', // 资源描述
        fileList: [], // 上传资源
        attachId: '',
        attachBizType: 'iot.firmware',
        attachHumanSize: '',
        attachPath: '',
        attachName: '',
        machineVersionList: [],
      },
      selectDeviceVisible: false,
      selectDeviceModel: {},
      productCode: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    create() {
      const retData = this.getReqData();
      this.$postJSON(apis.resourceSaveOrUpdate, retData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_add_success'),
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    save() {
      const retData = this.getReqData();
      this.$postJSON(apis.resourceSaveOrUpdate, retData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_edit_success'),
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    getReqData() {
      // supportPreVersion 改为了输入框、现在不用拼接了
      // const ret = { ...this.form, supportPreVersion: this.form.supportPreVersion ? this.form.supportPreVersion.join(',') : this.form.supportPreVersion };
      const ret = { ...this.form };
      return ret;
    },
    hasSameProductDifferentVersion(arr) {
      // 用一个 Map 存储 key 为 productSn + productCode，value 为 machineVersion 的集合
      const map = new Map();

      for (const item of arr) {
        const key = `${item.productSn}|${item.productCode}`;

        if (!map.has(key)) {
          map.set(key, { versions: new Set(), hasEmpty: false });
        }

        // 检查 machineVersion 是否为空
        if (item.machineVersion === '') {
          map.get(key).hasEmpty = true; // 标记该 key 存在空的 machineVersion
        } else {
          map.get(key).versions.add(item.machineVersion); // 添加非空的 machineVersion
        }
        // 如果存在空的 machineVersion 和非空的 machineVersion，返回 true
        if (map.get(key).hasEmpty && map.get(key).versions.size > 0) {
          return true;
        }
      }

      return false;
    },


    async onConfirm() {
      const hasSameProductVersion = this.hasSameProductDifferentVersion(this.form.machineVersionList);
      if (hasSameProductVersion) {
        this.$message.error(this.$t('dms_resource_item_dialog.qnqrxzdcpxznczygjqbb'));
        return;
      }
      if (!this.form.fileList.length) {
        this.$message.error(this.$t('dms_resource_item_dialog.qsczywj'));
        return;
      }
      await this.$refs.iotFirmware.submit();
      this.form.attachId = this.form.fileList[0].attachId;
      this.form.attachHumanSize = this.form.fileList[0].humanSize;
      this.form.attachPath = this.form.fileList[0].attachPath;
      this.form.attachName = this.form.fileList[0].attachName;
      this.form.attachSize = this.form.fileList[0].size;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.type === 'add') {
            await this.create();
          } else {
            await this.save();
          }
        }
      });
    },
    init() {
      if (this.model.type === 'edit') {
        const resourceId = this.model.data.resourceId;
        this.$getJSON(`${apis.resourceInfo}/${resourceId}`).then((res) => {
          this.$setFormatData(this.form, res.data);
          // this.form.supportPreVersion = this.form.supportPreVersion.split(',');
          // setTimeout(() => {
          //   // const curProduct = this.$refs.product.getSelectedNode();
          //   // this.curProductSn = curProduct.productCode;

          //   this.productQuery = {
          //     productCode: this.form.productCode,
          //   };

          //   this.form.componentCode = this.form.componentCode;
          //   // 更新请求数据，其他更新树方式无法解决params缓存问题(params缓存上一次的变更)
          //   this.componentSelectKey = Math.random();

          // }, 100);
        });
      }
    },
    // 选择设备
    onSelDevice() {
      this.selectDeviceModel = {
        title: this.$t('dms_resource_item_dialog.zcjqbb'),
        protocolCode: this.form.protocolCode,
      };
      this.selectDeviceVisible = true;
    },
    selDeviceConfirm(list) {
      // 假设 list 是你要添加的数组
      const combinedList = [...this.form.machineVersionList, ...list];
      // 使用 Map 进行去重
      const uniqueMap = new Map();
      // 遍历合并后的数组
      combinedList.forEach(item => {
        // 创建一个唯一的键，由 machineVersion、productCode 和 productSn 组合而成
        const key = `${item.machineVersion}|${item.productCode}|${item.productSn}`;
        // 只保留第一个出现的项
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, item);
        }
      });

      // 将去重后的结果一次性赋值回 this.form.machineVersionList
      this.form.machineVersionList = Array.from(uniqueMap.values());
      this.selectDeviceVisible = false;
    },
    deleteResource(index) {
      this.form.machineVersionList.splice(index, 1);
    }
  },
};
</script>

<style lang="scss">
.resource-item-dialog {
  .title {
    color: #35405b;
    font-size: 14px;
    margin-bottom: 18px;
    font-weight: bold;
  }
  .label-box {
    margin-top: 1px;
    line-height: 31px;
    background: rgba(245, 245, 245, 1);
    min-width: 90px;
    height: 31px;
    text-align: center;
    color: #262626;
    font-size: 12px;
    padding: 0 10px;
    margin-left: 6px;
  }

  .content {
    display: flex;
    .resource-msg {
      padding-right: 15px;
      // flex: 1;
      width: 720px;
      .single-img {
        width: 180px;
        height: 180px;
      }
      .add-child-btn {
          background: rgba(245, 245, 245, 1);
          border: 1px dashed rgba(228, 228, 228, 1);
          line-height: 30px;
          text-align: center;
          color: #333333;
          font-size: 12px;
          margin-top: 10px;
          cursor: pointer;
          .icon {
            color: #00afff;
            font-size: 10px;
            margin-right: 8px;
            float: left;
          }
        }
    }
    .handle-file {
      flex: 1;
      padding-left: 15px;
      border-left: 1px solid rgb(242, 243, 251);
    }
  }
}
</style>
